import Vue from 'vue'
import { mapState } from 'vuex'
import { LOT_SESSIONS_MANAGEMENT } from '@/constants/store.js'

const lotMixin = {
  computed: {
    ...mapState(LOT_SESSIONS_MANAGEMENT.NAMESPACE, {
      sessions: state => (state[LOT_SESSIONS_MANAGEMENT.STATE.SESSIONS] || [])
    }),
    lastOrCurrentSession () {
      const sessions = this.sessions
      // используем this.sessionTime для регулярного пересчета на форме торгов
      // т.к. этот объект постоянно обновляется по таймеру
      // и запускает пересчет всех зависимых computed свойств
      if (!sessions.length) {
        return null
      }
      // для пересчета lastOrCurrentSession следим за изменением serverTime
      // если serverTime пришел с сервера, то используем this.serverTime из миксина,
      // иначе получаем текущую дату на клиенте
      const now = this.sessionTime?.currentTime
        ? Vue.moment(this.sessionTime.currentTime, 'DD.MM.YYYY HH:mm:ss')
        : Vue.moment()

      // если первая сессия не началась, то считаем ее текущей, иначе последняя сессия
      // учитываем, что в двухэтапной торговой процедуре 2 сессии создаются одновременно
      const firstSession = sessions[0]
      if (firstSession && now
        .isBefore(Vue.moment(firstSession.dateEndWithProlongation))) {
        return firstSession
      }
      return sessions[sessions.length - 1] || null
    }
  }
}

export default lotMixin
